export const CONFIRMATION_STEP_ID = "confirmation";
export const CONFIRMATION_STEP_TITLE = "Preview and Finalize";
